import type { Options as CrossFlowOptions } from '@atlassiansox/cross-flow-component-support';

export const Journeys = {
	GET_STARTED: 'get-started',
	DECIDE: 'decide',
	DISCOVER: 'discover',
} as const;

export const Targets = {
	CONFLUENCE: 'confluence.ondemand',
	JIRA_CORE: 'jira-core.ondemand',
	JIRA_SERVICE_DESK: 'jira-servicedesk.ondemand',
	JIRA_SOFTWARE: 'jira-software.ondemand',
	JIRA_PRODUCT_DISCOVERY: 'jira-product-discovery',
	BITBUCKET: 'bitbucket.ondemand',
	TRELLO: 'trello',
	OPSGENIE: 'opsgenie',
	STATUSPAGE: 'statuspage',
	TEAM_CENTRAL: 'townsquare',
	ANALYTICS: 'atlassian-analytics-free',
} as const;

export type TargetType = (typeof Targets)[keyof typeof Targets];

export type Journey = (typeof Journeys)[keyof typeof Journeys];

export type JourneyTargetProductDefinition = {
	targetProduct: TargetType;
};

export type Options = {
	journey: Journey;
	productId: string;
	sourceComponent: string;
	sourceContext: string;
	extensions?: CrossFlowOptions['extensions'];
	extraAnalyticsAttributes?: CrossFlowOptions['extraAnalyticsAttributes'];
};

export interface CompletionStatus {
	success?: boolean;
}

export type WithAppProvisionProps = {
	appProvisioning: (options: Options) => Promise<CompletionStatus>;
};

// Temporary -- until cross flow supports CCP Keys
export type AppRecommendationsProduct = {
	appName: string;
	crossFlowReferenceId: string;
	tcsReferenceId: string;
};
export type AppRecommendationsProductMap = Record<string, AppRecommendationsProduct>;

export type AppRecommendationsArtifact = {
	products: AppRecommendationsProductMap;
};
